import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { isEmpty } from 'tools/string'
import { colors, colorConstants } from 'theme/default'
import { SmallText } from 'components/Typo'
import Component from 'decorators/Component'
import Input from 'components/Input'

const StyledInputAddOn = styled(Input.AddOn)`
  &&& {
    background-color: transparent;
  }

  cursor: pointer;
`

const StyledSmallText = styled(SmallText)`
  color: ${colors.text};

  &:hover {
    color: ${colorConstants.gray};
  }
`

class PasswordInput extends React.PureComponent {
  static propTypes = {
    ...Input.propTypes,
    label: PropTypes.string.isRequired
  }

  state = {
    mask: true
  }

  togglePasswordMask = () => {
    const { mask } = this.state
    this.setState({ mask: !mask })
  }

  render () {
    const { t, ...props } = this.props
    const { mask } = this.state

    return (
      <Input {...props} type={mask ? 'password' : 'text'}>
        {({ inputElement, value }) => (
          <React.Fragment>
            {inputElement}
            {!isEmpty(value) &&
            <StyledInputAddOn onClick={this.togglePasswordMask}>
              <StyledSmallText normalised>{mask ? t('Show') : t('Hide')}</StyledSmallText>
            </StyledInputAddOn>}
          </React.Fragment>
        )}
      </Input>
    )
  }
}

export default Component()(PasswordInput)
